import { Dimensions } from 'editor/src/store/design/types';

function getMockupId(size: Dimensions) {
  return `${size.width}x${size.height}`;
}

export default getMockupId;
